import { createFileRoute } from '@tanstack/react-router'
import { Budgeting } from 'pages/budgeting/Budgeting'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const enforceSiteId = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
})

const RouteComponent = () => {
  const { siteId } = Route.useSearch()

  return <Budgeting siteId={siteId} />
}

export const Route = createFileRoute('/budgeting/')({
  component: RouteComponent,
  validateSearch: enforceSiteId,
  staticData: {
    layout: {
      enableScrolling: true,
    },
  },
})
